import { Table, TableBody, TableRow, TableCell } from "@mui/material"
import { CustomerAnalysis } from '../GeneratedClients/FreeBillApi'
import { NumberField } from "react-admin"
import { useNavigate } from 'react-router-dom'

const CustomersTable = ({customerAnalysis, totalCustomers}: {customerAnalysis: CustomerAnalysis[], totalCustomers: number}) => {
  
  const navigate = useNavigate()
  const handleRowClick = (customerName?: string | null) => {
    navigate({
      pathname: "/invoices",
      search:`filter=${JSON.stringify(
        { companyName_Contains: customerName }
      )}`
    })
  }
  
  return (
    <Table size="small" sx={{mt:2}}>
      <TableBody>
        <TableRow>
          <TableCell>Name</TableCell>
          <TableCell>Netto-Umsatz</TableCell>
          <TableCell>Rechnungen</TableCell>
        </TableRow>
        {
          customerAnalysis.map((customer, i) =>
            i < totalCustomers &&
            <TableRow hover onClick={() => handleRowClick(customer.customerName)} sx={{cursor: "pointer"}} key={i}>
              <TableCell>{customer.customerName}</TableCell>
              <TableCell><NumberField record={customer} source="totalNetAmount" options={{ style: 'currency', currency: 'EUR' }} /></TableCell>
              <TableCell><NumberField record={customer} source="totalInvoices" /></TableCell>
            </TableRow>
          )
        }
      </TableBody>
    </Table>
  )
}

export default CustomersTable